import {Component, Input, Output, OnDestroy, OnInit, EventEmitter, ViewChild} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CustomValidator, Utils} from "@amlCore/utils";
import {AlertPanelComponent, AlertPanelService} from "@amlCore/components";
import {CheckDayReportParamsModel} from "../../../models/transaction/checkDayReportParamsModel";
import {StringDateAdapterService, ValidatorService} from "@amlCore/services";

/**
 * Компонент для ввода параметров отчета по результатам анализа операций за день
 */
@Component({
    selector: 'app-check-transaction-report',
    templateUrl: './checkTransactionDayReport.component.html'
})

export class CheckTransactionDayReportComponent implements OnInit, OnDestroy {
    @Output() onSave: EventEmitter<CheckDayReportParamsModel> = new EventEmitter();
    /**
     * Объект для отображения информации по сохранению
     */
    @ViewChild('alertObjSave', {static: true}) alertObjToSave: AlertPanelComponent;

    form: FormGroup;
    constructor(private formBuilder: FormBuilder,
                private modal: NgbActiveModal,
                private validatorSrv: ValidatorService,
                public dateSrv: StringDateAdapterService,
                ) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            date: ['', Validators.required],
            format: ['ods', Validators.required],
        });
    }

    ngOnDestroy(): void {}

    /**
     * Сохранить
     */
    save(){
        this.onSave.emit(Utils.clone(this.form.value));
        this.modal.dismiss(true);
    }

    f(field: string) {
        return this.form.get(field);
    }

    /**
     * Закрываем модальное окно
     */
    goBack() {
        this.modal.dismiss(false);
    }
}
